import { httpCreate } from './http';
const http = httpCreate('/srv/iconModelCustom');
export const iconModelCustom = {
	//打开自定义菜单
	save(activityId, data) {
		return http.post(`/save/${activityId}`, data);
	},
	//修改自定义菜单
	updae(id, data) {
		return http.put(`/update/${id}`, data);
	},
	//删除自定义菜单
	delete(id) {
		return http.delete(`/delete/${id}`);
	},
	//获取当前自定义菜单信息
	getCustom(id) {
		return http.get(`/${id}`);
	}
};
